
export  const sleep = ms => new  Promise(r => setTimeout(r, ms));


export function formatDate(milliseconds) {
    // Convert milliseconds to a Date object
    if (!milliseconds || milliseconds === 0) {
        return "Not Available";
    }

    const date = new Date(milliseconds);

    // Array of day names in Indonesian
    const days = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'];

    // Array of month names in Indonesian
    const months = [
        'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus',
        'September', 'Oktober', 'November', 'Desember'
    ];

    // Get the components
    const dayName = days[date.getDay()];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    // Format the time as HH:MM
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    // Build the formatted date string
    return `${dayName}, ${day} ${month} ${year} Pukul : ${hours}:${minutes} WIB`;
}


export const safeDateFormat = (value, withSeconds = false) => {
    if (!value) return "-";

    const date = new Date(value);
    if (isNaN(date.getTime())) return "-";

    const options = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    };

    if (withSeconds) options.second = "2-digit";

    return new Intl.DateTimeFormat("id-ID", options).format(date);
};
